import React, { Component, Fragment } from "react";

import { PieChart, Pie, Cell } from "recharts";

import {
  Metric,
  Error,
  isDateFromDataInISOFormat,
  formatDateFromData,
} from "./../../../Utils/Utils.js";

import numeral from "./../../../../../node_modules/numeraljs/numeral.js";
import SharedSocialLineChart from "./../../LineGraphs/SharedSocialLineChart/SharedSocialLineChart";

const COLORS = ["#F3108E", "#f4f4f4"];

class Facebook extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => {
    const data = this.childRef
      .getExportData()
      .data.map((e) => ({ ...e, name: e.full_date || e.date || e.name }));
    return {
      data: data,
      opts: {
        type: "chart",
        date: {
          name: "name",
          // overwrites the default settings for date only when the date is in ISO format
          defined: isDateFromDataInISOFormat(data),
          format: "YYYY-MM-DDThh:mm:ssZ",
          viewFormat: "YYYY-MM-DD",
        },
        values: ["current_value", "previous_value"],
      },
    };
  };

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    let preparedData = formatDateFromData(
      this.props.data.graph.map((e) => ({ ...e, name: e.full_date || e.name })),
      null,
      "name"
    );
    return (
      <Fragment>
        <div key={"stats"} className="row mb-4">
          <div className="col-6 col-sm-4 col-md-4 col-lg-4 mb-3">
            <h6 className="widget__metric-label">Views</h6>
            <Metric {...data.stats.views} size={"md"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-4 mb-3">
            <h6 className="widget__metric-label">Shares</h6>
            <Metric {...data.stats.shares} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-4 mb-3">
            <h6 className="widget__metric-label">Minutes Viewed</h6>
            <Metric {...data.stats.minutes_viewed} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-4 mb-3">
            <h6 className="widget__metric-label">Minutes Per Video</h6>
            <Metric
              {...data.stats.minutes_per_video}
              size={"sm"}
              type={"time"}
            />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-4 mb-3">
            <h6 className="widget__metric-label">Unique Viewers</h6>
            <Metric {...data.stats.unique_viewers} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-4 mb-3">
            <h6 className="widget__metric-label">Reactions</h6>
            <Metric {...data.stats.reactions} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-4 mb-3">
            <h6 className="widget__metric-label">Comments</h6>
            <Metric {...data.stats.comments} size={"sm"} />
          </div>

          <div key={"graph1"} className="col-4">
            <h6 className="widget__metric-label m-0">% Complete</h6>
            <PieChart height={45} width={45}>
              <Pie
                dataKey="value"
                data={data.stats.complete}
                outerRadius="100%"
                innerRadius="75%"
              >
                {data.stats.complete.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__xsmall"
              >
                {numeral(data.stats.complete[0].value).divide(100).format("%")}
              </text>
            </PieChart>
          </div>

          <div key={"graph2"} className="col-4">
            <h6 className="widget__metric-label ml-2 mt-2">% Paid</h6>
            <PieChart height={45} width={45}>
              <Pie
                dataKey="value"
                data={data.stats.paid}
                outerRadius="100%"
                innerRadius="75%"
              >
                {data.stats.paid.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__xsmall"
              >
                {numeral(data.stats.paid[0].value).divide(100).format("%")}
              </text>
            </PieChart>
          </div>
        </div>

        <SharedSocialLineChart
          ref={(el) => (this.childRef = el)}
          data={preparedData}
          color={"#F3108E"}
        />
      </Fragment>
    );
  }
}

export default Facebook;
